module.exports = __webpack_public_path__ + "img/card-prov-remedy-req-management-hover.bc782098.svg";